import {
  FiltersAggregateItem,
  FiltersRawItem,
  IExtendedFilterCollectionItem,
} from '@/interfaces/filters.interfaces';
import deepCopy from '@/utils/deepCopy';

import { FilterOperators, FiltersParameters } from '../types';

import splitCompositeFilterField from './splitCompositeFilterField';

const makeFiltersRawItem = (
  aggregateItem: FiltersAggregateItem,
  parameters: FiltersParameters,
) => {
  const filtersRawValuesMap = deepCopy(aggregateItem.data);

  const nestedReferencesMap: Record<string, IExtendedFilterCollectionItem[]> = {};
  const rangeFieldsMap: Record<string, number[]> = {};

  Object.entries(filtersRawValuesMap).forEach(([key, value]) => {
    const { key: filterKey, field, operator } = splitCompositeFilterField(key);

    // Фильтр включает множество элементов из разных коллекций
    if (FilterOperators.NestedField === operator && field) {
      if (Array.isArray(value)) {
        const references = value as IExtendedFilterCollectionItem[];

        references.forEach(ref => {
          if (ref?.[field.key] === field.value) {
            if (nestedReferencesMap[filterKey]) {
              if (!nestedReferencesMap[filterKey].find(r => r.id === ref.id)) {
                nestedReferencesMap[filterKey].push(ref);
              }
            } else {
              nestedReferencesMap[filterKey] = [ref];
            }
          }
        });

        delete filtersRawValuesMap[key];
      }
    }

    if (FilterOperators.Min === operator || FilterOperators.Max === operator) {
      const resolvedValue = value as number;
      const rangeValues = rangeFieldsMap?.[filterKey]?.slice() || [];

      if (FilterOperators.Min === operator) {
        rangeValues.unshift(resolvedValue || 0);
      } else {
        rangeValues.push(resolvedValue || 0);
      }

      rangeFieldsMap[filterKey] = rangeValues;

      delete filtersRawValuesMap[key];
    }
  });

  const filters = {
    id: `${+new Date()}`,
    envId: parameters.envId,
    spaceId: parameters.spaceId,
    collectionId: parameters.collectionId,
    data: {
      ...filtersRawValuesMap,
      ...nestedReferencesMap,
      ...rangeFieldsMap,
    },
  } as FiltersRawItem;

  return filters;
};

export default makeFiltersRawItem;
